$(document).ready(function () {
   const widths = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200,1300];
  let ranges = {};

  function addRange(glassType, values) {
    ranges[glassType] = {};
    for (let i = 0; i < widths.length; i++) {
      ranges[glassType][widths[i]] = values[i];
    }
  }

  function buildRanges(tykkelse) {
    console.log("Building ranges for tykkelse:", tykkelse);
    ranges = {};
    if (tykkelse === '0') {
      addRange("Klar glas", [4165, 4290, 4410, 4530, 4655, 5085, 5205, 5325, 5450, 5570, 5695, 5695]);
      addRange("Klar Jernfattig", [4645, 4835, 5030, 5225, 5415, 5915, 6110, 6300, 6495, 6690, 6880, 6880]);
      addRange("Materet glas", [4510, 4770, 5030, 5290, 5550, 6115, 6375, 6635, 6895, 7155, 7415, 7415]);
      addRange("Røgfarvet glas", [4345, 4535, 4730, 4925, 5115, 5615, 5810, 6000, 6195, 6390, 6580, 6580]);
      addRange("Bronzefarvet glas", [4345, 4535, 4730, 4925, 5115, 5615, 5810, 6000, 6195, 6390, 6580, 6580]);
      addRange("Riflet glas", [4990, 5440, 5890, 6340, 6790, 7545, 8000, 8450, 8900, 9350, 9800, 9800]);
    } else {
      addRange("Klar glas", [4765, 4890, 5010, 5130, 5255, 5685, 5805, 5925, 6050, 6170, 6295, 6295]);
      addRange("Klar Jernfattig", [5245, 5435, 5630, 5825, 6015, 6515, 6710, 6900, 7095, 7290, 7480, 7480]);
      addRange("Materet glas", [5110, 5370, 5630, 5890, 6150, 6715, 6975, 7235, 7495, 7755, 8015, 8015]);
      addRange("Røgfarvet glas", [4945, 5135, 5330, 5525, 5715, 6215, 6410, 6600, 6795, 6990, 7180, 7180]);
      addRange("Bronzefarvet glas", [4945, 5135, 5330, 5525, 5715, 6215, 6410, 6600, 6795, 6990, 7180, 7180]);
      addRange("Riflet glas", [4945, 5135, 5330, 5525, 5715, 6215, 6410, 6600, 6795, 6990, 7180, 7180]);
    }
  }

  // function getNearestWidth(width) {
  //   const nearest = widths.reduce((prev, curr) =>
  //     Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev
  //   );
  //   return nearest;
  // }
function getNearestWidth(width) {
  let w = Math.floor(width / 100) * 100;

  // Ensure it stays within allowed range
  if (w < 200) w = 200;
  if (w > 1300) w = 1300;

  return w;
}
  function getHeightSurcharge(height) {
    if (height <= 2000) return 0;
    if (height <= 2100) return 199;
    if (height <= 2200) return 299;
    if (height <= 2300) return 399;
    if (height <= 2400) return 499;
    return 0;
  }

  function updateTotalPrice() {
    const bredde = parseInt($('#bredde').val(), 10) || 500;
    const calchojde = parseInt($('#calchojde').val(), 10) || 2000;
    const glasType = $('input.glass-frame-box:checked').val();
    const profilfarvePrice = parseFloat($('input[name="properties[Profilfarve]"]:checked').data("profilfarve")) || 0;
    const belgningPrice = parseFloat($('input[name="properties[Belægning]"]:checked').data("belgning")) || 0;
    const tykkelse = $('input[name="properties[tykkelse]"]:checked').attr('data-tykkelse') || '0';
    buildRanges(tykkelse);
    const widthKey = getNearestWidth(bredde);
    const basePrice = ranges[glasType]?.[widthKey] || 0;
    const heightSurcharge = getHeightSurcharge(calchojde);
    const totalPrice = Math.floor(basePrice + profilfarvePrice + belgningPrice + heightSurcharge);
    $("#custom-priceTicker")
      .attr("data-main-price", basePrice)
      .attr("data-total-price", totalPrice)
      .text(totalPrice);
    $(".product-sticky-form__price").text(totalPrice + ' kr');
    $("#custom-qty").val(totalPrice);
  }

    $('input[name="properties[tykkelse]"]').on('change', function () {
    const selectedThickness = $(this).val();
    if (selectedThickness === "10mm") {
      $("#glas-riflet").prop("checked", false).prop("disabled", true);
      $('label[for="glas-riflet"]').addClass("hide-now");
    } else {
      $("#glas-riflet").prop("disabled", false);
      $('label[for="glas-riflet"]').removeClass("hide-now");
    }
    updateTotalPrice();
  });

  function limitInput() {
    const value = parseInt(this.value, 10);
    const max = parseInt(this.max, 10);
    const min = parseInt(this.min, 10);
    if (value > max) this.value = max;
    else if (value < min) this.value = min;
  }
  function updateImageBySelections() {
    const profilfarveVal = $('input[name="properties[Profilfarve]"]:checked').val();
    let newImgSrc = '';
    if (profilfarveVal === 'Blank Krom') {
      newImgSrc = $('.glass-frame-box:checked').data('img');
    } else if (profilfarveVal === 'Børstet') {
      newImgSrc = $('.glass-frame-box:checked').data('img-børstet');
    } else if (profilfarveVal === 'Messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-messing');
    } else if (profilfarveVal === 'Børstet messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-borstet-messing');
    } else if (profilfarveVal === 'Sort') {
      newImgSrc = $('.glass-frame-box:checked').data('img-sort');
    } else if (profilfarveVal === 'Børstet kobber') {
      newImgSrc = $('.glass-frame-box:checked').data('img-kobber');
    }
    if (newImgSrc) {
      $('.update-img img').attr('src', newImgSrc).removeAttr('srcset');
      $('.pswp__img').attr('src', newImgSrc).removeAttr('srcset');
    }
  }
  $('input[name="properties[tykkelse]"]').on('change', updateTotalPrice);
  $("#bredde, #calchojde").on("input", updateTotalPrice);
  $("input.glass-frame-box").on("change", function () {
    updateImageBySelections();
    updateTotalPrice();
  });

  $('input[name="properties[Profilfarve]"]').on("change", function () {
    updateImageBySelections();
    updateTotalPrice();
  });

document.getElementById('AddToCart').addEventListener('click', function () {
  updateTotalPrice();
});

window.addEventListener('load', function () {
  updateTotalPrice();
});

window.addEventListener('pageshow', function (event) {
  updateTotalPrice();
});

  
  $('input[name="properties[Belægning]"]').on("change", updateTotalPrice);

  // $('.custom-radio-input.profilfarve').on('change', function () {
  //   const selectedTitle = $(this).val().trim();
  //   $('.profilfarve-heading').text('Vælg glastype med ' + selectedTitle.toLowerCase() + ' profilfarve');
  // });

  document.getElementById("bredde").addEventListener("change", limitInput);
  document.getElementById("calchojde").addEventListener("change", limitInput);

  // Initial Setup
  updateImageBySelections();
  updateTotalPrice();
      setInterval(function() {
      updateImageBySelections();
    }, 10); // interval
  $(document).on('click', '.product__zoom-button', function() {
        setInterval(function() {
    updateImageBySelections();
              }, 10); // interval
});
});


